const FORCE_RELOAD_PARAM = 'forceReload';
const FORCE_RELOAD_AT_PARAM = 'forceReloadAt';

export const shouldForceReloadVtt = (url: string): boolean => {
  const parsed = new URL(url);
  const forceReload = parsed.searchParams.get(FORCE_RELOAD_PARAM) === 'true';

  return forceReload;
};

export const appendVttReloadCacheBust = (url: string): string => {
  const parsed = new URL(url);
  parsed.searchParams.set(FORCE_RELOAD_PARAM, 'true');
  parsed.searchParams.set(FORCE_RELOAD_AT_PARAM, String(Date.now()));
  return parsed.toString();
};
